import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { DealerUserService } from '../../services/dealer-user/dealer-user.service';
import { ModuleAccessService } from '../../services/module-access/module-access.service';

export const ownerGuard: CanActivateFn = (): Observable<boolean> => {
  const moduleAccessService = inject(ModuleAccessService);
  const dealerUserService = inject(DealerUserService);
  const router = inject(Router);

  return moduleAccessService.newSite$.pipe(
    take(1),
    switchMap((newSite) => {
      if (newSite) {
        console.log(
          '%c New Site is enabled: skip ownerGuard',
          'background: green; color: white',
        );
        return of(true);
      }

      return dealerUserService.currentDealerUser_IsOwner$.pipe(
        take(1),
        tap((isOwner) => {
          console.log(
            '%c * Route uses Owner guard * ',
            'background: black; color: white',
          );
        }),
        map((isOwner) => {
          if (isOwner) {
            console.log(
              '%c DealerUser is Owner > allowed ',
              'background: green; color: white',
            );
            return true;
          }

          console.log(
            '%c DealerUser is not an Owner ',
            'background: red; color: white',
          );
          router.navigate(['/dashboard']);
          return false;
        }),
      );
    }),
  );
};
